import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { connect } from "react-redux";
import { FormEmployeeComboBox, useEmployeeOptions } from "@advosys/component-advosys-react";
import { EmployeeType } from "@advosys/component-app-server-client-js";
import { DialogForm, FormText } from "@advosys/component-react";
import { getObjectWithValues, useForm, useValidationRules } from "@advosys/component-react-form";
import { actions } from "../../dynamic-invoice-page-store";
import { useT } from "./forward-dialog-i18n";
const mapStateToProps = (state) => state.dynamicInvoices.dynamicInvoicesPages.dynamicInvoicesPage.page.dialogSubmitting;
const ForwardDialogBase = (props) => {
    const { t } = useT();
    const { maxLength, required } = useValidationRules();
    const { preparedInvoiceIds, submitting, submitError, forwardPreparedInvoiceRequest, hideForwardDialog } = props;
    const employeeOptions = useEmployeeOptions("b7542974-be7e-4717-939b-398ceede3e15", EmployeeType.All);
    const { formState, formController, validateForm } = useForm({
        submitting,
        validation: {
            validators: {
                comment: () => [maxLength(1000)],
                approverUserId: () => [required]
            }
        }
    });
    const handleSubmit = () => {
        if (validateForm()) {
            const values = getObjectWithValues(formController, formState);
            forwardPreparedInvoiceRequest(preparedInvoiceIds, values);
        }
    };
    return (_jsxs(DialogForm, { dialogProps: { size: "small", header: t.dialogHeader, isBlocking: true }, isSubmitting: submitting, submitError: submitError, hasUnsavedChanges: false, onSubmit: handleSubmit, cancel: { onCancel: hideForwardDialog }, submitButtonProps: { text: t.submitButtonText }, preventDisableSubmitButtonWhenUnsavedChanges: true, children: [_jsx(FormEmployeeComboBox, { data: employeeOptions, label: t.employeeLabel, formFieldController: formController.approverUserId, formFieldState: formState.approverUserId }), _jsx(FormText, { label: t.commentLabel, formFieldController: formController.comment, formFieldState: formState.comment, multiline: { growMultiline: true } })] }));
};
export const ForwardDialog = connect(mapStateToProps, actions)(ForwardDialogBase);
